import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { useTranslation } from 'react-i18next';

import { useChargePointContext } from '../../charge-point.context';

export const ChargePointDeleteFormStep1Controller = (): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const chargePoint = useChargePointContext();

  // RENDER //////////////////////////////////////////////////////////////////

  return (
    <>
      <Text bold>
        {t('$.charge-point-delete.step-1.confirm', {
          name: chargePoint.name,
        })}
      </Text>
      <Text italic>{t('$.charge-point-delete.step-1.warning')}</Text>
    </>
  );
};
